export enum FeatureFlagNames {
  NEW_AUTH_MODULE = "NEW_AUTH_MODULE",
  NEW_ORGANIZATION_MODULE = "NEW_ORGANIZATION_MODULE",
  NEW_PROJECT_MODULE = "NEW_PROJECT_MODULE",
  NEW_APPLICATION_MODULE = "NEW_APPLICATION_MODULE",
  NEW_USER_MODULE = "NEW_USER_MODULE",
}

export enum ModuleNames {
  AUTH = "auth",
  ORGANIZATION = "organization",
  PROJECT = "project",
  APPLICATION = "application",
  USER = "user",
}
